define('services/screenpopService',[
    'viewModels/ViewModel',
    'lib/knockout',
    'services/loggingService',
    'lib/lodash4'
], function (ViewModel, ko, loggingService, _) {
    'use strict';

    /**
     * The PopupService offers to the application a way to cleanly abstract the management of popup windows from
     * application components. If a popup window is created through the popupService, the service will track it until
     * it is closed by the user.
     *
     * This information can be consumed by application components that need to avoid making duplicate popups.
     *
     */
    var ScreenpopService = function () {
        var self = this;

        /**
         * A map of urls to window handles.
         */
        var popups = ko.observable({});

        /**
         * Removes a popup URI from the map of popups.
         */
        var removePopupFromMap = function (uri) {
            if (popups()[uri]) {
                delete popups()[uri];
            }
        };

        /**
         * Continuously monitors a window and removes it from the popups map if it is closed.
         */
        var monitorPopupRecursive = function monitorPopupRecursive(uri, popup) {
            if (popup.closed) {
                removePopupFromMap(uri);
            }
            else {
                window.setTimeout(monitorPopupRecursive, 250, uri, popup);
            }
        };

        /**
         * Opens a URI and returns a handle to the popup window.
         */
        self.open = function (uri) {
            if (popups()[uri] === undefined) {
                var popup = window.open(uri);
                if (popup) {
                    monitorPopupRecursive(uri, popup);
                    popups()[uri] = popup;
                    return popup;
                }
                else {
                    loggingService.error('The browser failed to create a popup. This may be from a popup blocker.', uri);
                }
            }
            else {
                loggingService.info('Popup is already open.', uri);
            }
        };

        /**
         * Closes a URI.
         */
        self.closeAll = function () {
            _.each(popups(), function (popup, uri) {
                removePopupFromMap(uri);
                popup.close();
            });
        };
    };

    var screenpopService = new ScreenpopService();

    return screenpopService;
});

